import { render } from "./EditCategoryModal.vue?vue&type=template&id=085e42f3&scoped=true"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js"

import "./EditCategoryModal.vue?vue&type=style&index=0&id=085e42f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085e42f3"]])

export default __exports__